import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { encryptData } from "helpers";
import { decryptData } from "helpers";
import { getHeaderConfig } from "helpers";
import { consoleLog } from "helpers";

export const sendResetPasswordLink = async (
  payload,
  setIsLoading,
  accessJWT
) => {
  try {
    setIsLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    consoleLog([" Token used:", accessJWT]);
    consoleLog(["Payload sent:", payload]);
    consoleLog(["Request config:", config]);

    const response = await axios.post(
      `${ENDPOINT}/app/v1/users/passwordlink`,
      encryptData(payload),
      config
    );

    consoleLog([response, "responseresponse"]);

    const parsedResponseData = JSON.parse(decryptData(response?.data));
    consoleLog([parsedResponseData, "resetPasswordResponse"]);

    if (parsedResponseData?.statusCode === 200) {
      return parsedResponseData.data;
    } else {
      throw new Error("Failed to send reset password link");
    }
  } catch (error) {
    console.error("Error sending reset password link:", error);
    return null;
  } finally {
    setIsLoading(false);
  }
};

export const resetPassword = async (payload, setIsLoading, accessJWT) => {
  try {
    setIsLoading(true);

    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}/app/v1/users/password`,
      encryptData(payload),
      config
    );

    const parsed = JSON.parse(decryptData(response?.data));
    consoleLog(["Reset Password Response:", parsed]);
    return parsed;
  } catch (error) {
    console.error("Error resetting password:", error);
    return null;
  } finally {
    setIsLoading(false);
  }
};

export const getUserDetailsByToken = async (token, setIsLoading, accessJWT) => {
  try {
    setIsLoading(true);
    

    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}/app/v1/users/detailByAuthToken`,
      encryptData({ token }),
      config
    );

    const parsed = JSON.parse(decryptData(response?.data));
    consoleLog(["User Details:", parsed]);
    return parsed;
  } catch (error) {
    console.error("Error fetching user details:", error);
    return null;
  } finally {
    setIsLoading(false);
  }
};

